import React,{ useState } from 'react';

const Apply = (props) => {
  const {mailSubjects, regions, searchName, setApply, setSearchName} = props;
  const [selectedRegion, setSelectedRegion] = useState(searchName ? [searchName] : []);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [subject, setSubject] = useState([mailSubjects[0]]);
  const [responseStatus, setResponsStatus] = useState('');
  const [error, setError] = useState('');

  const isEnabled = email.length > 0 &&  name.length > 0 && selectedRegion.length > 0 && subject.length > 0 && message.length > 0;

  const closeModal = () => {
    setSearchName('');
    setApply(false);
  }

  const handleSubmit = (e) => {
    const theRegion = selectedRegion ? selectedRegion.toString() : searchName;
    e.preventDefault();
    const values = {
      name: name,
      region: theRegion,
      subject: subject.toString(),
      message: message,
      email: email,
    }
    const url = process.env.LAMBDA_GATEWAY_API_ENDPOINT;
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(values),
    })
    .then((res) => res.json())
    .then((res) => setResponsStatus(res.data.statusCode))
    .catch((err) => setError(err))
  }

  const optionsSelect = (e) => {
    if (e.target.name === "region" ) {
      if (selectedRegion.includes(e.target.value)){
        setSelectedRegion.length < 1 && setSelectedRegion([])
        const filtered = selectedRegion.filter(item => item !== e.target.value);
        setSelectedRegion(filtered);
      } else {
        setSelectedRegion([...selectedRegion, e.target.value])
      }
    } else {
      if (subject.includes(e.target.value)){
        subject.length < 1 && setSubject([])
        const filtered = subject.filter(item => item !== e.target.value);
        setSubject(filtered);
      } else {
        setSubject([...subject, e.target.value])
      }
    }
  }

   return (
    <div className='apply-modal'>
      <div className='form-wrapper'>
        <div className= 'close-btn'>
          <button onClick={() => closeModal()}>X</button>
        </div>
        {!responseStatus ?
          <form className='apply' onSubmit={(e) => handleSubmit(e)}>
            <h2>För dig som redan är volontär men vill engagera dig ännu mer.</h2>
            <div className='select-wrapper'>
              <div className='select-item'>
                <label htmlFor='regions'>Välj kommun:</label>
                <div className='custom-select'>
                  <select name='region' value={selectedRegion ? selectedRegion : searchName} multiple id='regions' onChange={(e) => optionsSelect(e)} >
                    {!searchName && <option key={'no selected region'} value=''>- Välj kommun -</option>}
                    {regions.map((reg, index) => (
                      reg.node.regionName !== null && 
                      <option key={`${reg}${index}`} value={reg.node.regionName}>{reg.node.regionName}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className='select-item'>
                <label htmlFor='subject'>Välj ärende:</label>
                <select name='subject' id='subject'  multiple value={subject} onChange={(e) => optionsSelect(e)}>
                  {mailSubjects.map((sub, index) => (
                    <option key={`${sub}${index}`} value={sub}>{sub}</option>
                  ))}
                </select>
              </div>
            </div>
            <p>Dina ärenden: 
            {subject.map(item => (
              <span>{` ${item},`}</span>
            ))}
            </p>
                <p>Dina kommuner: 
            {selectedRegion.map(item => (
              <span>{` ${item},`}</span>
            ))}
            </p>
            <input type='text' name='name' placeholder='Namn' onChange={(e) => setName(e.target.value)}/>
            <input type='email' name='email' placeholder='Email' onChange={(e) => setEmail(e.target.value)}/>
            <textarea type='text' name='message' placeholder='Meddelande...' onChange={(e) =>  setMessage(e.target.value)}/>
            <input type='submit' value={isEnabled ? 'Skicka': 'Fyll i samtliga fält'} disabled={!isEnabled}/>
          </form>
        : 
          <div className='form-message-sent'>
            <h2>{error ? 'Ditt meddelande skickades inte' : 'Ditt meddelande har skickats.'}</h2>
            <p>{error ? 'Någonting gick fel, försök igen lite senare.' : 'Stort tack för att du vill vara med i vårat förebyggade arbete.'}</p>
          </div>
        }
      </div>
    </div>
  );
};

export default Apply;